import { ReactNode } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [
  { screen: '(max-width: 767px)', width: '56px' },
  { screen: '(min-width: 768px)', width: '96px' },
]
export default function HeaderTitle({
  children,
  iconSrc,
  iconAlt,
}: {
  children: ReactNode
  iconSrc: string
  iconAlt: string
}): React.ReactElement {
  return (
    <div className="mt-auto lg:mt-4 space-x-4 flex items-end">
      <ResponsiveImage
        alt={iconAlt}
        height={56}
        imageClassName="w-14 lg:w-24"
        imageWidths="56, 96"
        mediaQuery={mediaQuery}
        srcKey={iconSrc}
        width={56}
      />
      <h1 className="text-h3 lg:text-h1 flex-1 font-semibold leading-none text-white">{children}</h1>
    </div>
  )
}
